import React, { useRef } from 'react'
import IdleTimer from 'react-idle-timer'
import { Logout } from '../util/HelpfulFunctions';

function IdleTimerComponent() {
    const idleTimerRef = useRef(null) 
    const timeOut = 1 * 60 * 60 * 1000 // 1 hours

    const onIdle = () => {
        if(localStorage.hasOwnProperty('lastActiveTime')){
            let newDate = new Date().getTime();
            let oldDate = Date.parse(localStorage.getItem('lastActiveTime'));

            if(newDate - oldDate > timeOut - 1000){
                Logout();
            }
        }
    }

    const onAction = (event) => {
        if(event.type === 'mousedown'){
            if(localStorage.hasOwnProperty('lastActiveTime')){
                if(((new Date()) - localStorage.getItem('lastActiveTime')) > timeOut - 1000){
                    Logout();
                }else{
                    localStorage.setItem('lastActiveTime', new Date());
                }
            }
        }
    }

    // hour min sec milsec
    return(
        <div>
            <IdleTimer 
                ref={idleTimerRef}
                timeout={timeOut}
                onAction={onAction}
                onIdle={onIdle}
            />
        </div>
    );
}
export default IdleTimerComponent